import { ChunkPickEvent } from "../Event/ChunkPickEvent";
import { ChunkPickerView } from "../View/ChunkPickerView";
import { ViewDelegate, CustomerIntegrationController as SrvgCustomerIntegrationController,
         ModelUpdateEvent, GuiResizeEvent, ChannelSwitchEvent } from "@gaming/srvg-classes-core";
import { Chunk } from "../Data/Chunk";
import { Timeline } from "../Data/Timeline";
import { CHUNK_MODEL_CHUNK } from "../Model/ChunkModel";
import { PhaseChangeEvent } from "../Event/PhaseChangeEvent";
import { COMPETITION_MODEL_COMPETITION } from "../Model/CompetitionModel";
import { sendPostMessage } from '../utils/sendPostMessage';

// to control chunk picker with chunkPickEvent use delegates
export interface ChunkPickerViewDelegate extends ViewDelegate {
    handleChunkPickEvent(event:ChunkPickEvent, provider:ChunkPickerView);
}

const gpActions = {
    INIT_RGS_EA_COMMUNICATION: 'INIT_RGS_EA_COMMUNICATION',
    RGS_EA_COMMUNICATION_INITIALIZED: 'RGS_EA_COMMUNICATION_INITIALIZED',
    RGS_EA_COMMUNICATION: 'RGS_EA_COMMUNICATION'
}

export class CustomerIntegrationController extends SrvgCustomerIntegrationController {
    previouslySentChunk:Chunk;

    timeline:Timeline;
    //@ts-expect-error sorry, this is a design mistake, the type in the class thats being extended for this property is entirely different and its coming from a module...
    matchday:PhaseChangeEvent;

    gpCommunication: boolean;

    //delegate for picking a specific chunk in the chunk area
    delegate:ChunkPickerViewDelegate;

    lastGpMessage;

    constructor(options) {
        options = options || {};
        options.name = options.name || 'customerIntegrationController';
        super(options);
        this.previouslySentChunk = null;

        this.postMessageHandler = this.postMessageHandlerFunction.bind(this);
        this.generatedEvents.push(ChunkPickEvent);
        this.timeline = options.timeline;
        this.gpCommunication = false;
        window.addEventListener('message', this.postMessageHandler);
    }

    protected callParentFunction(parentFunctionName:string, functionParameters:any) {
        if( window.self == window.top ) {
            // Not inside an iframe
            return;
        }
        var sameOrigin:boolean = undefined;
        try
        {
            sameOrigin = window.parent.location.host == window.location.host;
        }
        catch (e)
        {
            sameOrigin = false;
        }
        if( !sameOrigin ) {
            // Parent iframe not of same origin
            return;
        }
        if( window.parent[parentFunctionName] ) {
            try {
                return window.parent[parentFunctionName](functionParameters);
            }
            catch (error) {
                console.log(
                    'An error occured while calling ' + parentFunctionName + ' in parent frame:',
                    error
                );
            }
        }
        else {
            //console.log(new Error('Function ' + parentFunctionName + ' does not exist in parent frame'));
        }
    }

    postMessageHandlerFunction(event: any) {
        if (event.data.messageType === gpActions.INIT_RGS_EA_COMMUNICATION) {
            this.gpCommunication = true;
            parent.postMessage({ messageType: gpActions.RGS_EA_COMMUNICATION_INITIALIZED }, '*');
            parent.postMessage(this.lastGpMessage, '*');
        }
    }

    handleModelUpdateEvent(event:ModelUpdateEvent, provider) {
        if (event.propertyName == CHUNK_MODEL_CHUNK) {
            var parentFunctionName = null;
            const matchPhase = 'match'; 

            if (app.name == "web-league" || app.name == "web-micro") {
                parentFunctionName = 'setVfMatches';
            }
            else {
                parentFunctionName = 'setVfecMatches';
            }

            var newChunk = <Chunk>event.propertyValue;
            // only call parent when the selected matchday changes
            if (!this.previouslySentChunk || !this.previouslySentChunk.isEqualTo(newChunk)) {
                this.previouslySentChunk = newChunk;


                // prepare match information
                var match_ids = [];
                var uf_match_ids = [];
                for (var i = 0; i < newChunk.matches.length; i++) {
                    match_ids.push(newChunk.matches[i].id);
                    uf_match_ids.push(srvg.config.unifiedPrefixes.match+newChunk.matches[i].id);
                }

                var chunkConfig = srvg.chunks[newChunk.nr];
                var names:any = {};
                // set chunk texts
                names.competition = newChunk.getCompetitionName();
                names.title = newChunk.getName();
                names.subtitle = newChunk.getDescription();



                // set feed information
                var setVfChunkInformation = {
                    "competition_id": newChunk.competition.id,
                    "season_id": newChunk.competition.id,
                    "competition_nr": newChunk.competition.nr,
                    "season_nr": newChunk.competition.nr,
                    "competition_stage_type": newChunk.competitionStageType,
                    "matchset_nr": newChunk.matches[0].matchset.nr,
                    "match_day": newChunk.matches[0].matchset.nr,
                    "match_ids": match_ids,
                    "screen_name": app.name,
                    "unique_tournament_id": srvg.product.uniqueTournamentId,
                    "event_start": newChunk.start * 1000, // convert to milliseconds
                    "round_part": chunkConfig.round_part || null,
                    "names": names,
                    // add unified feed informaton
                    "uf_competition_id": srvg.config.unifiedPrefixes.season+newChunk.competition.id,
                    "uf_match_ids": uf_match_ids,
                    "uf_tournament_id": srvg.config.unifiedPrefixes.tournament+srvg.product.uniqueTournamentId

                };

                // send customerMessage (setVfMatches/setVfecMatches) via parent.setVfMatches / parent.setVfecMatches
                if(parent) {
                    this.callParentFunction(parentFunctionName, setVfChunkInformation);
                }

                // send customerMessage (setVfMatches/setVfecMatches) via parent.postMessage
                var customerMessage = {};
                customerMessage[parentFunctionName] = setVfChunkInformation;

                sendPostMessage(parentFunctionName, customerMessage, true);
                sendPostMessage('setMatches', setVfChunkInformation);

                const gpMessage = {
                    messageData: {
                        competition_stage_type: newChunk.competitionStageType,
                        competition_nr: newChunk.competition.nr,
                        competition_id: newChunk.competition.id,
                        event_start: newChunk.start * 1000,
                        match_ids: match_ids,
                        uf_match_ids: uf_match_ids,
                        match_day: newChunk.matches[0].matchset.nr,
                        uf_competition_id: srvg.config.unifiedPrefixes.season+newChunk.competition.id,
                        unique_tournament_id: srvg.product.uniqueTournamentId,
                        stage_title: names.title,
                        period: this.matchday.phase.name,
                        servertime: app.server.getTime(),
                        selectedMatchdayIsLive: this.matchday.phase.name === matchPhase && this.matchday.chunk.nr === newChunk.matches[0].matchset.nr
                    },
                    messageType: gpActions.RGS_EA_COMMUNICATION
                }

                this.lastGpMessage = gpMessage;

                if (this.gpCommunication)  {
                    parent.postMessage(gpMessage, '*');
                }



            }
        }
        else if( event.propertyName == COMPETITION_MODEL_COMPETITION ) {
            // Competition model was updated
            if( srvg.featuresInstances.getReloadAfterCompetition() ) {
                // if there was a previous competition
                if( event.propertyPreviousValue ) {
                    // reload the page
                    window.location.reload();
                }
            }
        }
    }

    handleGuiResizeEvent(event:GuiResizeEvent, provider) {
        var parentFunctionName = null;

        // league calls its own function...
        if (app.name == "web-league" || app.name == "web-micro") {
            parentFunctionName = 'setVfHeight';
        }
        else {
            parentFunctionName = 'setVfecHeight';
        }

        if (parent) {
            var heightInformation = {
                height: document.body.clientHeight,
                screen_name: app.name,
                unique_tournament_id: srvg.product.uniqueTournamentId
            };
            this.callParentFunction(parentFunctionName, heightInformation);
        }

        sendPostMessage(parentFunctionName, JSON.stringify({messageData: {setVfHeight: {height: document.body.clientHeight}}, messageType: "setVfHeight"}), true);
        sendPostMessage('setHeight', { height: document.body.clientHeight});
    }


    /**
     * used for storing seasons and matchday information of the current match
     * to pick them for overlays or statistic center etc.
     * @param event
     * @param provider
     */
    handlePhaseChangeEvent(event:PhaseChangeEvent, provider) {
        // FIXME does this if work? Because there is not "matchday" in event.
        if( event['matchday'] ) {
            var matchday = event['matchday'];
            if (matchday.getSeason() && matchday.getSeason().id) {
                this.seasonId = matchday.getSeason().id;
                this.addClickHandler();
            }
        }

        if(event['chunk'] && event.chunk.competition.id){
            this.seasonId = event.chunk.competition.id;
        }

        this.matchday = event;

        var now = app.server.getTime();
        var vfStatus = {
            servertime: now,
            current: {
                chunk_nr:               event.chunk.nr,
                matchset_nr:            event.chunk.matches[0].matchset.nr,
                competition_stage_nr:   event.chunk.matches[0].matchset.competitionStage.nr,
                season_nr:              event.chunk.competition.nr
            },
            period: event.phase.name,
            countdown: event.phase.end-now,
            screen_name: app.name,

            // add unified feed informaton
            uf_season: srvg.config.unifiedPrefixes.season+event.chunk.competition.nr

        }


        // send customerMessage (setVfStatus) via parent.setVfStatus
        this.callParentFunction('setVfStatus', vfStatus);


        // send customerMessage (setVblMatchday) via parent.postMessage
        var customerMessage = {
            setVfStatus: vfStatus
        };
        parent.postMessage(customerMessage, "*");
        //console.log('send customerMessage (vfStatus) via parent.postMessage: ' + JSON.stringify(customerMessage, null, 4), "info");


    }


    /**
     * open statistic center with head to head page
     * @param teamIdHome
     * @param teamIdAway
     * @param seasonId
     */
    /*openStatisticHead2head(teamIdHome: number, teamIdAway: number, seasonId: number){
     // assemble link
     var url = srvg.url.statisticlink;
     if( srvg.customization.teamIds[teamIdHome] ) { teamIdHome = srvg.customization.teamIds[teamIdHome]; }
     if( srvg.customization.teamIds[teamIdAway] ) { teamIdAway = srvg.customization.teamIds[teamIdAway]; }
     url = url.replace("%team1%", teamIdHome).replace("%team2%", teamIdAway);
     url = url.replace("%seasonid%", seasonId);

     // open assembled link
     this.openStatisticWindow(url);
     }*/


    /**
     * opens pop up windows with given url
     * @param url
     */
    /*        openStatisticWindow(url){
     var wnd = window.open(
     url,
     'statistic',
     'width=1024,height=727,scrollbars=1,resizable=1');
     // window.open seems to return null on IE9
     if( wnd ) { wnd.focus(); }
     }
     */
    /**
     * interface for customer integration method setVfecSelectedMatchday
     * timestamp given, chose on chunk and pick it in chunk picker
     * @param timestamp (unix timestamp in seconds)
     */
    setSelectedMatchdayByTimestamp(timestamp:number) {
        var chunk = this.timeline.chunkRangeModel.findChunkByTimestamp(timestamp);
        if (chunk) {
            this.triggerEvent(new ChunkPickEvent(chunk));

            if(srvg.config.matchdayPicker == true){
                app.viewController.matchdayPickerLeagueViewController.highlightSelectedMatchday(chunk.nr);
            }
        }
    }


    /**
     * interface for customer integration method setSelectedMatchday
     * matchday given, chose on chunk and pick it in chunk picker
     * @param timestamp (unix timestamp in seconds)
     */
    setSelectedMatchday(matchday:number, nextSeason: boolean ) {

        var chunkElement = null;

        // array starts at 0 but holds matchday 1
        chunkElement = matchday-1;

        // nextSeason parameter set
        if(nextSeason) {
            // chunk is in next season so we add 30 (matchdays)
            chunkElement = matchday-1+30;
        }
        else {
            chunkElement = matchday-1;
        }

        // if desired chunk exists and nr of the chunk matches desired matchday
        if(this.timeline.chunkRangeModel.chunks[chunkElement] &&
            this.timeline.chunkRangeModel.chunks[chunkElement].nr == matchday) {
            this.triggerEvent(new ChunkPickEvent(this.timeline.chunkRangeModel.chunks[chunkElement]));

            // if matchdaypicker is configured we need to mark the selected matchday
            // as matchday == chunknr+1 we need to set accordingly
            if(srvg.config.matchdayPicker == true){
                app.viewController.matchdayPickerLeagueViewController.highlightSelectedMatchday(chunkElement+1);
            }
        }
    }

    setChannel(channel){
        this.triggerEvent(new ChannelSwitchEvent(channel));
    }

    destroy() {
        window.removeEventListener('message', this.postMessageHandler);
        super.destroy();
    }
}
